<template>
  <Menu
    v-model:selectedKeys="selectedKeys"
    v-model:openKeys="openKeys"
    theme="light"
    mode="inline"
    @click="handleMenu"
    class="page-menu"
    style="height: calc(100% - 48px)"
  >
    <template v-for="item in menus" :key="item.path">
      <template v-if="item?.meta?.hideChildrenInMenu">
        <MenuItem :key="item.path">
          <i class="iconfont home-icon" :class="item?.meta?.icon"></i>
          {{ item?.meta?.title }}
        </MenuItem>
      </template>
      <template v-else>
        <SubMenu :key="item.path">
          <template #icon>
            <i class="iconfont" :class="item?.meta?.icon"></i>
          </template>
          <template #title>{{ item?.meta?.title }}</template>
          <MenuItem :key="menu.path" v-for="menu in item.children">{{
            menu?.meta?.title
          }}</MenuItem>
        </SubMenu>
      </template>
    </template>
  </Menu>
</template>

<script lang="ts" setup>
import { ref, unref, watch } from "vue";

import { Menu } from "ant-design-vue";
import { useRouter } from "vue-router";
import { useAuth } from "/@/hooks/web/useAuth";

const { SubMenu, Item: MenuItem } = Menu;

const router = useRouter();
const menus = router.getRoutes().filter((item) => {
  if (item?.children.length > 0) {
    item.children = item.children.filter(
      (child: any) => !child?.meta.hideMenu && useAuth(child?.meta.code)
    );
  }
  return (
    item?.children.length > 0 &&
    !item?.meta.hideMenu &&
    useAuth(item?.meta.code)
  );
});

const selectedKeys = ref<string[]>([]);
const openKeys = ref<string[]>([]);
const { currentRoute } = router;

const setupMenu = () => {
  const route = unref(currentRoute);
  const routePath = route?.meta?.belong || route.path;
  const openPath = route.matched[0].path;
  selectedKeys.value = [routePath];
  openKeys.value = [openPath];
};
function handleMenu(item) {
  router.push({
    path: item.key,
  });
}
watch(
  () => currentRoute.value.path,
  (newPath) => {
    setupMenu();
  },
  {
    immediate: true,
  }
);
</script>
<style lang="less" scoped>
.home-icon {
  padding-right: 12px;
}
</style>
